module.exports = __webpack_public_path__ + "media/src/images/dandori/step1-dbb2d186e9bdc6dbf805b751cfb908fe.png";